import { graphql } from '../../../gql';

export const BOOKMARK_POST_MUTATION = graphql(`
  mutation bookmarkPost($input: BookmarkPostInput!) {
    bookmarkPost(input: $input) { success postId bookmarkCount }
  }
`);

export const UNBOOKMARK_POST_MUTATION = graphql(`
  mutation unbookmarkPost($input: BookmarkPostInput!) {
    unbookmarkPost(input: $input) { success postId bookmarkCount }
  }
`);
